export const LOG_USER_IN = 'LOG_USER_IN'
export const LOG_USER_OUT = 'LOG_USER_OUT'
export const SET_LOGIN_DETAILS = 'SET_LOGIN_DETAILS'
export const SET_USER_ID = 'SET_USER_ID'
export const INITIALIZE_TOKEN_VERIFICATION = 'INITIALIZE_TOKEN_VERIFICATION'
export const SET_VERIFYING_TOKEN = 'SET_VERIFYING_TOKEN'
export const SET_AUTH_ERROR = 'SET_AUTH_ERROR'
export const SET_AUTH_MESSAGE = 'SET_AUTH_MESSAGE'
export const SET_AUTH_VALUE = 'SET_AUTH_VALUE'
export const SET_RESETTING_PASSWORD = 'SET_RESETTING_PASSWORD'
export const SET_UPDATING_PASSWORD = 'SET_UPDATING_PASSWORD'
export const SET_REQUESTING_NEW_TOKEN = 'SET_REQUESTING_NEW_TOKEN'
export const SET_LOGGING_IN = 'SET_LOGGING_IN'
export const SET_AUTH_STATUS = 'SET_AUTH_STATUS'
export const AUTH_FAILED = 'AUTH_FAILED'
export const RESET_LOGIN_MESSAGES = 'RESET_LOGIN_MESSAGES'
export const SET_RESETTING_INCORRECT_LOGIN_COUNTER = 'SET_RESETTING_INCORRECT_LOGIN_COUNTER'
export const SET_INITIAL_STATE = 'SET_INITIAL_STATE'
export const SET_ISSUING_RESET_PASSWORD_INSTRUCTIONS = 'SET_ISSUING_RESET_PASSWORD_INSTRUCTIONS'
export const SET_ISSUING_NEW_REGISTRATION_EMAIL = 'SET_ISSUING_NEW_REGISTRATION_EMAIL'
export const SET_RESET_PASSWORD_MESSAGE = 'SET_RESET_PASSWORD_MESSAGE'
export const SET_TOKEN_ERROR = 'SET_TOKEN_ERROR'
export const SET_SSO_AUTH_ERROR = 'SET_SSO_AUTH_ERROR'
export const ACCEPTED_TERMS = 'ACCEPTED_TERMS'
export const SET_TOKEN_USER_MESSAGE = 'SET_TOKEN_USER_MESSAGE'
export const SET_CLOSE_SMS_PROMPT = 'SET_CLOSE_SMS_PROMPT'
